// Activity events only the browser sees — an audio briefing listened to, a
// module opened, a file or e-mail draft opened, a logout — for the owner's
// Activity view (POST /api/activity/track, recorded on the instance the user
// works on). Fire and forget: never blocks or fails what the user does.
import { API_BASE_URL, getAuthHeaders, getToken } from '../auth';

export function track(kind, { area = '', title = '', durationMs, detail } = {}) {
  try {
    if (!getToken()) return;
    fetch(`${API_BASE_URL}/api/activity/track`, {
      method: 'POST',
      keepalive: true,
      headers: getAuthHeaders({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({
        kind, area, title,
        duration_ms: Number.isFinite(durationMs) ? Math.round(durationMs) : undefined,
        detail,
      }),
    }).catch(() => {});
  } catch (e) { /* activity must never break the app */ }
}

/** A new id that groups one chat's turns into a conversation. */
export function newConversationId() {
  try {
    if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  } catch (e) { /* fall through */ }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}
